const PieIcon: React.FC<{ size?: string; color?: string }> = ({
  size = "12",
  color = "currentColor",
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.76516 0.287406C5.04263 0.254706 5.32221 0.328003 5.54794 0.492627C5.77368 0.65725 5.92891 0.901054 5.98258 1.17524L5.99716 1.27266L6.00008 1.33332V5.41666C6.0001 5.55953 6.05255 5.69744 6.14749 5.80421C6.24244 5.91098 6.37326 5.97919 6.51516 5.99591L6.58341 5.99999H10.5501C10.8595 5.99999 11.1562 6.12291 11.375 6.3417C11.5938 6.56049 11.7167 6.85724 11.7167 7.16666C11.7167 7.21103 11.7116 7.25526 11.7016 7.29849C11.4681 8.30571 10.9712 9.23278 10.2616 9.98478C9.55203 10.7368 8.65534 11.2867 7.66336 11.5781C6.67138 11.8696 5.61975 11.8922 4.61617 11.6436C3.61259 11.3949 2.69312 10.8841 1.95192 10.1632C1.21072 9.44237 0.674427 8.53748 0.39796 7.54121C0.121493 6.54494 0.114786 5.49309 0.378526 4.49338C0.642267 3.49367 1.16698 2.58201 1.89892 1.85178C2.63087 1.12155 3.54375 0.598971 4.54408 0.337572L4.70158 0.298489L4.76516 0.287406Z"
        fill={color}
      />
      <path
        d="M7.1665 1.04163V4.24996C7.1665 4.40467 7.22796 4.55304 7.33736 4.66244C7.44675 4.77184 7.59513 4.8333 7.74984 4.8333H10.9582C11.0514 4.83327 11.1433 4.81089 11.2261 4.76804C11.3089 4.72519 11.3802 4.66312 11.4341 4.58702C11.488 4.51092 11.5228 4.42302 11.5357 4.33068C11.5486 4.23833 11.5392 4.14425 11.5083 4.0563C11.2185 3.23341 10.7479 2.48598 10.1311 1.86905C9.51428 1.25212 8.76693 0.781397 7.94409 0.491545C7.8561 0.460473 7.76195 0.450961 7.66953 0.463806C7.57711 0.476652 7.48912 0.51148 7.41295 0.565368C7.33677 0.619255 7.27464 0.69063 7.23176 0.773501C7.18887 0.856372 7.1665 0.94832 7.1665 1.04163Z"
        fill="black"
      />
    </svg>
  );
};
export default PieIcon;
